import { useQuery, QueryFunction } from '@tanstack/react-query';
import { apiClient } from 'src/libs/axios';
import { userKeys } from './user-keys';
import { QueryOptions } from 'src/libs/react-query';
import { useAccount } from 'wagmi';
import { useAuth } from 'src/libs/rainbow';

export type GetUserInfoResponse = {
  address: string;
  balance: number;
  chain_id: number;
  connected_at: string;
  created_at: string;
  email: string;
  id: string;
  is_accept_terms: boolean;
  is_vnt: boolean;
  is_vnt_at: string | null;
  referral_code: string;
  referred_by: string | null;
  role: string;
  updated_at: string;
  has_sbt: boolean;
  has_referral_fee_discount: boolean;
  metadata?: {
    early_tester?: boolean;
    [key: string]: unknown;
  } | null;
};

export const getUserInfo = async () => {
  const { data } = await apiClient.get(`/v2/users/info`);
  return data ?? [];
};

export type UseGetUserInfoOptions<TData, TError> = QueryOptions<
  GetUserInfoResponse,
  TError,
  TData,
  ReturnType<typeof userKeys.userInfo>
>;

export const useGetUserInfo = <TData = GetUserInfoResponse, TError = Error>(
  userId: string,
  options?: UseGetUserInfoOptions<TData, TError>,
) => {
  const { isAuthenticated, isEthereumWallet } = useAuth();
  return useQuery({
    queryKey: userKeys.userInfo(userId),
    queryFn: getUserInfo,
    enabled: isAuthenticated && isEthereumWallet,
    ...options,
  });
};
